import React, { useEffect, useState } from 'react';

import { useLocalStorage } from 'react-use';

import WelcomeModal from '@pkg/components/OnboardingTutorial/WelcomeModal';
import { useMediaQuery } from '@pkg/providers';

export const WELCOME_MODAL_STORE_KEY = 'welcome-modal-onboarding';

export const PodsOnboarding = () => {
    const { tablet } = useMediaQuery();

    // --> Pods/Welcome Tutorial
    const [isWelcomeModalShown, setWelcomeModalShown] = useLocalStorage(WELCOME_MODAL_STORE_KEY);
    const [showWelcomeModal, setShowWelcomeModal] = useState(false);

    const onCloseWelcomeModal = () => {
        setShowWelcomeModal(false);
        setWelcomeModalShown('true');
    };

    useEffect(() => {
        if (isWelcomeModalShown) return;
        const handleLoad = () => {
            setShowWelcomeModal(true);
        };
        const timeout = setTimeout(handleLoad, 2000);
        return () => clearTimeout(timeout);
    }, [isWelcomeModalShown]); // Need to only trigger on route change

    if (tablet) {
        if (showWelcomeModal) return <WelcomeModal onClose={onCloseWelcomeModal} />;
    }
    return null;
};
